import { BreakpointsLayoutSize } from "@entaconsulting/form";

const getMostGenericBreakpoint = (
  size: BreakpointsLayoutSize
): keyof BreakpointsLayoutSize => {
  const breakpoints = Object.keys(size) as (keyof BreakpointsLayoutSize)[];
  const orderedBreakpoints = breakpoints.sort((a, b) => {
    const order = ["sm", "md", "lg"];
    return order.indexOf(a) - order.indexOf(b);
  });

  if (orderedBreakpoints.length === 0) {
    return "sm";
  }

  const mostGenericBreakpoint = orderedBreakpoints.at(-1)!;
  return mostGenericBreakpoint;
};

export default getMostGenericBreakpoint;
